import React, { useState, useEffect } from "react";
import Select from "react-select";
import CustomDatePicker from "../../../components/Custom-Datepicker";
import EditorComponent from "../../../components/editor";
import { useNavigate } from "react-router-dom";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { confirm } from "../../../components/Confirmation";
import { use } from "react";

const customStyle = {
  control: (provided, state) => ({
    ...provided,
    height: "80px",
    overflow: "scroll",
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    color: "white", // Sets the color of the cancel icon
    ":hover": {
      backgroundColor: "red", // Adjust hover background color if needed
      color: "white", // Adjust hover color here
    },
  }),
};

export const experienceOptions = [
  { value: "0 - 1 Years", label: "0 - 1 Years" },
  { value: "0.6 - 2 Year", label: "0.6 - 2 Year" },
  { value: "2 - 4 Year", label: "2 - 4 Year" },
  { value: "4 - 6 Years", label: "4 - 6 Years" },
  { value: "6 - 8 Years", label: "6 - 8 Years" },
  { value: "7 - 9 Years", label: "7 - 9 Years" },
  { value: "8 - 10 Years", label: "8 - 10 Years" },
  { value: "10 - 12 Years", label: "10 - 12 Years" },
  { value: "12 - 14 years", label: "12 - 14 years" },
  { value: "13 - 16 Years", label: "13 - 16 Years" },
  { value: "15 - 18 Years", label: "15 - 18 Years" },
  { value: "18 - 20 Years", label: "18 - 20 Years" },
  { value: "20+ Years", label: "20+ Years" },
];

const AddCustomerRequirement = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Add Customer Requirement"));
  }, []);
  const [rows, setRows] = useState(1);
  const RMG_STATUS_LOOKING_FOR_PROFILES = 7024;

  const initialFormData = {
    JobCode: "",
    PositionName: "",
    Description: "",
    Technology: [],
    NumOpenings: "",
    OpeningType: "",
    RequirementHiringType: "",
    ClientID: "",
    LocationType: "",
    Location: [],
    MinExp: "",
    MaxExp: "",
    Client_Priority: "",
    Shift: "",
    RomID: "",
    Reason:"",
    JobStatus: 6749,
    IsInActive: "",
    Priority: "1",
    Client_poc: "",
    Role: "",
    RequirementDate: "",
    BillingStartDate: "",
    skill: [],
    ProjectType: "Consulting",
    AccountManager: "",
    TenureFrequency: null,
    Revenue: "",
    Rate: "",
    RegionID: "",
    Tenure: "",
    Currency: "",
    RequirementType: "Customer",
    TrackerID: "",
    JobFamilyID: "",
    PersonalAreaID: "",
    PersonalSubAreaID: "",
    RequisitionSourceID: "",
    EmployeeGroup_ID: "",
    BillingTypeID: "",
    RMGStatusID: RMG_STATUS_LOOKING_FOR_PROFILES
  };

  const validationSchema = Yup.object().shape({
    Description: Yup.string().required("Description is required"),
    NumOpenings: Yup.number().required("NumOpenings is required"),
    Client_Priority: Yup.number()
      .typeError("Client Priority is required") // Custom error message for invalid number type
      .required("Client Priority is required"),
    Role: Yup.string().required("Role is required"),
    ClientID: Yup.number()
      .typeError("Client Name is required") // Custom error message for invalid number type
      .required("Client Name is required"),
    Currency: Yup.string().required("Currency is required"),
    Tenure: Yup.number()
      .typeError("Tenure is required") // Custom error message for invalid number type
      .required("Tenure is required"),
    Rate: Yup.number()
      .typeError("Rate is required") // Custom error message for invalid number type
      .required("Rate is required"),
    TenureFrequency: Yup.string().required("Tenure Frequency is required"),
    RequirementDate: Yup.string().required("Date is required"),
    BillingStartDate: Yup.string().required("Billing Start Date is required"),
    CostFrequency: Yup.string().required("Cost Frequency is required"),
    LocationType: Yup.string(),
    JobStatus: Yup.string(),
    Reason:Yup.string(),
    MinExp: Yup.string()
      .typeError("Relv Exp is required") // Custom error message for invalid number type
      .required("Relv Exp is required"),

    MaxExp: Yup.string()
      .typeError("Total Exp is required") // Custom error message for invalid number type
      .required("Total Exp is required"),

    NumOpenings: Yup.number()
      .typeError("Openings # is required") // Custom error message for invalid number type
      .required("Openings # is required"),

    Location: Yup.array()
      .required("Location is required")
      .min(1, "Location is required"),
    HiringType: Yup.string().required("Engagement Type is required"),
    RequirementHiringType: Yup.string().required("Hiring Type is required"),
    Priority: Yup.string().required("RMG Priority is required"),
      Technology: Yup.array()
        .required("Sub Skill is required")
        .min(1, "At least one sub-skill must be selected"), // Ensure at least one item in array
      skill: Yup.array()
        .required(" Skill is required")
        .min(1, "At least one skill must be selected"),
      TrackerID: Yup.string().when("RequirementHiringType", {
        is: "1",
        then: (schema) => schema.required("Track is required"),
        otherwise: (schema) => schema.nullable()
      }),
      JobFamilyID: Yup.string().when("RequirementHiringType", {
        is: "1",
        then: (schema) => schema.required("Job Family is required"),
        otherwise: (schema) => schema.nullable()
      }),
      PersonalSubAreaID: Yup.string().when("RequirementHiringType", {
        is: "1",
        then: (schema) => schema.required("Personal Sub Area is required"),
        otherwise: (schema) => schema.nullable()
      }),
      RequisitionSourceID: Yup.string().when("RequirementHiringType", {
        is: "1",
        then: (schema) => schema.required("Requisition Source is required"),
        otherwise: (schema) => schema.nullable()
      }),
      EmployeeGroup_ID: Yup.string().when("RequirementHiringType", {
        is: "1",
        then: (schema) => schema.required("Employee Group is required"),
        otherwise: (schema) => schema.nullable()
      }),
      RMGStatusID: Yup.string().when("RequirementHiringType", {
        is: "1",
        then: (schema) => schema.required("RMG Status is required"),
        otherwise: (schema) => schema.nullable()
      }),
      PersonalAreaID: Yup.string().when("RequirementHiringType", {
        is: "1",
        then: (schema) => schema.required("Personal Area is required"),
        otherwise: (schema) => schema.nullable()
      }),
      BillingTypeID: Yup.string().when("RequirementHiringType", {
        is: (val) => val !== "4",
        then: (schema) => schema.required("Billing Type is required"),
        otherwise: (schema) => schema.nullable()
      }),
    });
const validateField = async (name, value) => {
  // If Client 354 is selected, instantly ignore validation for locked fields
  const internalOption = requirementTypeOptions.find(o => o.code === 'INT' || String(o.label).toLowerCase() === 'internal');
  const isLocked = internalOption && (String(formData?.RequirementType) === String(internalOption.value));
  const fieldsToSkip = ["Tenure", "Rate", "TenureFrequency", "CostFrequency", "Client_Priority", "Currency", "Revenue", "BillingStartDate"];
  
  if (isLocked && fieldsToSkip.includes(name)) {
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    return true;
  }

  try {
    await validationSchema.validateAt(name, { ...formData, [name]: value }); 
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); 
    return true;
  } catch (err) {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: err.message, 
    }));
    return false;
  }
};

const validateForm = async () => {
  try {
    await validationSchema.validate(formData, { abortEarly: false }); // Validate entire form
    setErrors({}); // Clear all errors
    return true;
  } catch (err) {
    const newErrors = {};

    // 1. Map validation errors safely, ignoring internal schema mismatch paths
    if (err.inner) {
      err.inner.forEach((curr) => {
        // Only map if it's a real field validation message, not a schema crash
        if (curr.path && !curr.message.includes("schema does not contain the path")) {
          newErrors[curr.path] = curr.message;
        }
      });
    }

    // 2. Clear out client 354 read-only blockers
  const internalOption = requirementTypeOptions.find(o => o.code === 'INT' || String(o.label).toLowerCase() === 'internal');
  const clientReadOnlyFlag = internalOption && (String(formData?.RequirementType) === String(internalOption.value));
    if (clientReadOnlyFlag) {
      const fieldsToSkip = [
        "Tenure", 
        "Rate", 
        "TenureFrequency", 
        "CostFrequency", 
        "Client_Priority", 
        "Currency", 
        "Revenue",
        "BillingStartDate"
      ];
      
      fieldsToSkip.forEach(field => {
        delete newErrors[field];
      });
    }

    setErrors(newErrors); // Set cleaned form-level errors
    
    // 3. Return true if NO errors are left after skipping the read-only fields!
    return Object.keys(newErrors).length === 0;
  }
};

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => {
      const updated = { ...prevState, [name]: value };
      if (name === "RequirementType") {
        updated.Currency = "";
        updated.CostFrequency = "";
        updated.Rate = "";
        updated.Tenure = "";
        updated.TenureFrequency = null;
        updated.Revenue = "";
      }
      return updated;
    });
    validateField(name, value); // Validate this field on change
  };

  const handleSelect = (e, name) => {
    const value = e.value;
    setFormData((prevState) => {
      const updated = { ...prevState, [name]: value };
      if (name === "ClientID") {
        updated.Currency = "";
        updated.CostFrequency = "";
        updated.Rate = "";
        updated.Tenure = "";
        updated.TenureFrequency = null;
        updated.Revenue = "";
      }
      return updated;
    });
    validateField(name, value); // Validate this field on change
  };

  const handleMultiSelect = (selectedOption, fieldName) => {
    setFormData((prevState) => {
      // Ensure selectedOption is an array and add it to the previous values
      const updatedState = {
        ...prevState,
        [fieldName]: Array.isArray(selectedOption)
          ? selectedOption // If it's already an array, just use it
          : [...prevState[fieldName], selectedOption], // Otherwise, add the selected option
      };
      return updatedState;
    });

    // Ensure you're validating the correct field
    validateField(fieldName, selectedOption);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const internalOption = requirementTypeOptions.find(o => o.code === 'INT');
    const clientReadOnlyFlag = internalOption && (String(formData?.RequirementType) === String(internalOption.value));
  
    const isValid = await validateForm();
    if (isValid) {
      if (Number(formData.NumOpenings) > 1) {
        const isConfirmed = await confirm(`You have entered ${formData.NumOpenings} openings, so ${formData.NumOpenings} entries will be created. Do you want to continue?`, "Yes", "No", { title: "Confirm Submission" });
        if (!isConfirmed) {
          return;
        }
      }

      setLoading(true);
      try {
        const response = await PostServiceCaller(
          `${API_URL}requirement`,
          {
            JobCode: "",
            PositionName: formData?.PositionName,
            Description: formData.Description,
            Technology: formData.Technology,
            NumOpenings: formData.NumOpenings,
            OpeningType: formData.OpeningType,
            HiringType: formData.HiringType,
            RequirementHiringType: formData.RequirementHiringType,
            ClientID: formData.ClientID,
            RequirementType: formData.RequirementType,
            LocationType: formData.LocationType,
            Location: formData.Location,
            MinExp: formData.MinExp,
            MaxExp: formData.MaxExp,
            Client_Priority: formData.Client_Priority,
            Shift: formData.Shift,
            RomID: formData?.RomID,
            Reason: formData?.Reason,
            JobStatus: formData.JobStatus,
            IsInActive: formData.IsInActive,
            Priority: formData.Priority,
            Client_poc: formData.Client_poc,
            Role: formData.Role,
            RequirementDate: formData.RequirementDate,
            BillingStartDate: formData.BillingStartDate,
            skill: formData.skill,
            ProjectType: formData.ProjectType,
            AccountManager: formData.AccountManager,
            RegionID: formData.RegionID,
            TrackerID: formData.TrackerID,
            JobFamilyID: formData.JobFamilyID,
            PersonalAreaID: formData.PersonalAreaID,
            PersonalSubAreaID: formData.PersonalSubAreaID,
            RequisitionSourceID: formData.RequisitionSourceID,
            EmployeeGroup_ID: formData.EmployeeGroup_ID,
            BillingTypeID: formData.BillingTypeID,
            RMGStatusID: formData.RMGStatusID,
            Currency: clientReadOnlyFlag ? "" : formData.Currency, 
            CostFrequency: clientReadOnlyFlag ? "" : formData.CostFrequency,
            Rate: clientReadOnlyFlag ? 0 : Number(formData.Rate || 0),
            Tenure: clientReadOnlyFlag ? 0 : Number(formData.Tenure || 0),
            TenureFrequency: clientReadOnlyFlag ? "" : formData.TenureFrequency,
            Revenue: clientReadOnlyFlag ? "0" : formData.Revenue,
          },
          "post"
        );

        if (response.status === 200) {
          toast.success("Data submitted successfully");
          setTimeout(() => {
            window.location.href = "/customer-requirement";
          }, 2000);
        } else {
          console.error(
            "Failed to submit data. Server responded with status:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error while submitting data:", error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          toast.error(error.response.data.error, { position: "top-right" });
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [jobTitleOption, setJobTitleOption] = useState([]);
  const [jobStatusOption, setJobStatusOption] = useState([]);
  const [currecyOption, setCurrecyOption] = useState([]);
  const [requirementTypeOptions, setRequirementTypeOptions] = useState([]);

  const [clientOption, setClientOption] = useState([]);
  const [locationOption, setLocationOption] = useState([]);
  const [trackOption, setTrackOption] = useState([]);
  const [jobFamilyOption, setJobFamilyOption] = useState([]);
  const [experienceOption, setExperienceOption] = useState([]);
  const [personalAreaOption, setPersonalAreaOption] = useState([]);
  const [personalSubAreaOption, setPersonalSubAreaOption] = useState([]);
  const [requisitionSourceOption, setRequisitionSourceOption] = useState([]);
  const [employeeGroupOption, setEmployeeGroupOption] = useState([]);
  const [billingTypeOption, setBillingTypeOption] = useState([]);
  const [rmgStatusOption, setRmgStatusOption] = useState([]);
  const [formData, setFormData] = useState(initialFormData);
  const [regionoption, setRegionoption] = useState([]);
  console.log("formData:::", formData);

  const hiringTypeOption = [
    { value: "", label: "Select" },
    { value: "1", label: "New FTE" },
    { value: "4", label: "Internal FTE" },
    { value: "2", label: "Contracting" },
    { value: "3", label: "ALL" },
  ];

  const projectTypeOption = [
    // { value: "", label: "Select" },
    { value: "Consulting", label: "Consulting" },
    { value: "Content", label: "Content" },
    { value: "Training", label: "Training" },
  ];

  const priorityOption = [
    { value: "", label: "Select" },
    { value: "3", label: "Low" },
    { value: "2", label: "Med" },
    { value: "1", label: "High" },
  ];

  const typeOfOpeningOption = [
    { value: "", label: "Select" },
    { value: "Fresh", label: "Fresh" },
    { value: "Replacement", label: "Replacement" },
  ];

  const loctype = [
    { value: "Offshore", label: "Offshore" },
    { value: "Onsite", label: "Onsite" },
    { value: "Remote", label: "Remote" },
  ];

  const [originalFrequencyOptions, setOriginalFrequencyOptions] = useState([]);
  const [engTypeOption, setEngTypeOption] = useState([]);
  const [frequencyOption, setFrequencyOption] = useState(
    originalFrequencyOptions
  );
  const oriTenureFrequency = [
    { value: "", label: "" },
    { value: 1, label: "Day" },
    { value: 2, label: "Month" },
    { value: 3, label: "Hourly" },
  ];

  // State to store tenure frequency
  const [originalTenureFrequency, setOriginalTenureFrequency] =
    useState(oriTenureFrequency);
  const [tenureFrequency, setTenureFrequency] = useState(null);

  useEffect(() => {
    fetchCustomerRequirementfilter();
  }, []);

  const [pageLoading, setPageLoading] = useState(false);
  // const fetchCustomerRequirement = async () => {
  //   setPageLoading(true)
  //   try {
  //     const response = await GetServiceCaller(
  //       `${API_URL}requirement?P_FromDate&P_ToDate&P_Id&P_HiringType`
  //     );
  //     if (response.status === 200) {
  //       setPageLoading(false)
  //       const cleanedData = response?.data?.data?.headers;
  //       setLoading(false);
  //     } else {
  //       console.error(
  //         "Failed to fetch partnerMaster. Server responded with status:",
  //         response.status
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error fetching PartnerMaster:", error);
  //   }
  // };

  const fetchCustomerRequirementfilter = async () => {
    setPageLoading(true)
    try {
      const response = await GetServiceCaller(`${API_URL}customer-filter-data`);
      if (response.status === 200) {
        setPageLoading(false);
        const jobTitleOptions = response?.data?.data?.jobtitle.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );
        setJobTitleOption(jobTitleOptions);
        // Client list
        const clientOptions = response?.data?.data?.client.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setClientOption(clientOptions);

        const engagementTypeOptions = response?.data?.data?.engagement_type.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );

        setEngTypeOption(engagementTypeOptions);

        const CurrOptions = response?.data?.data?.currency.map((record) => ({
          value: record.ID,
          label: record.Name,
          symbol: record.CurrencySymbol,
        }));

        setCurrecyOption(CurrOptions);

        const reqTypeOpts = response?.data?.data?.requirement_type?.map((record) => ({
          value: record.value,
          label: record.text,
          code: record.code,
        })) || [];
        
        if (reqTypeOpts.length === 0) {
          console.warn('RequirementType options not loaded from DB. Check REQUIREMENT_TYPE master code.');
        }
        setRequirementTypeOptions(reqTypeOpts);
        
        const customerOption = reqTypeOpts.find(o => o.code === 'CUST');
        if (customerOption) {
          setFormData(prev => ({ ...prev, RequirementType: customerOption.value }));
        }

        const regionOpt = response?.data?.data?.region?.map((record) => ({
          value: record?.value,
          label: record?.text,
        }));
        setRegionoption(regionOpt);

        const frequencyOptions = response?.data?.data?.frequency.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );

        setOriginalFrequencyOptions(frequencyOptions);



        const rompocOptions = response?.data?.data?.rompoc.map((record) => ({
          value: record.value,
          label: record.text,
        }));

        const jobStatusOptions = response?.data?.data?.jobstatus.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );
        setJobStatusOption(jobStatusOptions);
        const locationOptions = response?.data?.data?.location.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );
        setLocationOption(locationOptions);

        const trackOptions = response?.data?.data?.track?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setTrackOption(trackOptions);

        const jobFamilyOptions = response?.data?.data?.job_family?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setJobFamilyOption(jobFamilyOptions);

        const experienceOptions = response?.data?.data?.experience?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setExperienceOption(experienceOptions);

        const personalAreaOptions = response?.data?.data?.personal_area?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setPersonalAreaOption(personalAreaOptions);

        const personalSubAreaOptions = response?.data?.data?.personal_sub_area?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setPersonalSubAreaOption(personalSubAreaOptions);

        const requisitionSourceOptions = response?.data?.data?.requisition_source?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setRequisitionSourceOption(requisitionSourceOptions);

        const employeeGroupOptions = response?.data?.data?.employee_group?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setEmployeeGroupOption(employeeGroupOptions);

        const rmgStatusOptions = response?.data?.data?.rmg_status?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setRmgStatusOption(rmgStatusOptions);

        const billingTypeOptions = response?.data?.data?.billing_type?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setBillingTypeOption(billingTypeOptions);

        const skillOptions = response?.data?.data?.skills.map((record) => ({
          value: record.ID,
          label: record.Name,
        }));
        setSkillSetOptions(skillOptions);

        const subSkillData = response?.data?.data?.subskills;
        const options = subSkillData.map((subSkill) => ({
          value: subSkill.ID,
          label: subSkill.SubSkill,
        }));
        // setSubSkillOptions1(options);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  const fetchSubSkillOptions = async (skill_id) => {
    try {
      let data = { skillId: skill_id };
      const response = await PostServiceCaller(
        API_URL + "fetch-subskils",
        data,
        "post"
      );
      const subSkillData = response.data;

      const options = subSkillData.map((subSkill) => ({
        value: subSkill.ID,
        label: subSkill.SubSkill,
      }));
      setSubSkillOptions1(options);
    } catch (error) {
      console.error("Error fetching subSkill options:", error);
    }
  };

  const [skillSetOptions, setSkillSetOptions] = useState([]);
  const [subSkillOption1, setSubSkillOptions1] = useState([]);
  const [skillValue, setSkillValue] = useState([]);

  const handleSkillChange = async (selectedOptions) => {
    // Extract the values from selected options
    const selectedValues = selectedOptions.map((option) => option?.value);

    // Join the selected values into a comma-separated string
    const skillValues = selectedValues.join(",");

    // Initialize or use existing Technology array
    const existingTechnology = formData.skill || [];

    // Create a new array with the last selected skill added if valid
    const lastSkill = selectedOptions[selectedOptions.length - 1];
    const skillSetArray = lastSkill?.value
      ? [...existingTechnology, lastSkill]
      : [...existingTechnology];

    // Update the formData with the updated Technology array
    setFormData({ ...formData, skill: skillSetArray });

    // Update the state with the selected skill values (as an array)
    setSkillValue(selectedValues);

    // Fetch sub-skill options with the current skill values
    if (skillValues != "") {
      fetchSubSkillOptions(skillValues);
    } else {
      setSubSkillOptions1([]);
      setFormData((prevData) => ({
        ...prevData,
        Technology: [],
      }));
    }
  };

  const [subSkillValue, setSubSkillValue] = useState([]);
  const [errors, setErrors] = useState();

  const handleSubSkillChange = (selectedOptions) => {
    let subSkill = selectedOptions[selectedOptions.length - 1];
    let subSkillSetArray = formData.Technology || [];
    setSubSkillValue(subSkillSetArray);
    if (subSkill?.value) {
      subSkillSetArray.push(subSkill);
    }
  };

  useEffect(() => {
    if (formData.ClientID) {
      fetchClientId(formData.ClientID);
    }
    setFormData((prevData) => ({
      ...prevData,
      RomID: "",
      RegionID: "",
      AccountManager: "",
    }));
  }, [formData.ClientID]);

  const [clientSelectRomPoc, setClientSelectRomPoc] = useState([]);
  const [clientRegion, setclientRegion] = useState([]);
  const [clientSelectAccountManager, setClientSelectAccountManager] = useState(
    []
  );

  const [projectManagerValue, setProjectMagerValue] = useState();

  const [clientPartnerValue, setClientPartnerValue] = useState();
  const [deliveryPartnerValue, setDeliveryPartnerValue] = useState();

  const fetchClientId = async (id) => {
    try {
      const data = { P_ClientID: id };
      const response = await PostServiceCaller(
        API_URL + "Client-id",
        data,
        "post"
      );
      const clientData = response.data.ClientID;

      const clientRomPocOptions = clientData.map((data) => ({
        label: data.RomPOC,
        value: data.RomPocID,
      }));
      const clientRegion = clientData
        .filter((data, index, self) => 
          index === self.findIndex((d) => d.RegionID === data.RegionID)
        )
        .map((data) => ({
          label: data.RegionName,
          value: data.RegionID,
        }));

      const clientAccountManagerOptions = clientData.map((data) => ({
        value: data.AccountManagerID,
        label: data.AccountManager,
      }));
      
      setRegionoption(clientRegion);
      setClientSelectRomPoc(clientRomPocOptions);
      setClientSelectAccountManager(clientAccountManagerOptions);
      const CPValue = clientData
        ?.filter((data) => data.TypeID === 6837)
        .map((data) => data?.CRM_ManagerName);

      const DPValue = clientData
        ?.filter((data) => data.TypeID === 6836)
        .map((data) => data?.CRM_ManagerName);

      const PMValue = clientData
        ?.filter((data) => data.TypeID === 6838)
        .map((data) => data?.CRM_ManagerName);

      setClientPartnerValue(CPValue);
      setProjectMagerValue(PMValue);
      setDeliveryPartnerValue(DPValue);

      // Set RomID and AccountManager in one call to avoid race conditions
      setFormData((prevData) => ({
        ...prevData,
        RomID: clientRomPocOptions.length ? clientRomPocOptions[0].value : "",
        RegionID: clientRegion.length ? clientRegion[0].value : "",
        AccountManager: clientAccountManagerOptions.length
          ? clientAccountManagerOptions[0].value
          : "",
      }));
    } catch (error) {
      console.error("Error fetching client options:", error);
    }
  };

  const clientPriorityOptions = [
    // { value: "", label: "" },
    { value: 1, label: "Hot" },
    { value: 2, label: "Cold" },
    { value: 3, label: "Warm" },
  ];

  useEffect(() => {
    // setFormData((prevData) => ({
    //   ...prevData,
    //   CostFrequency: null,
    //   TenureFrequency: null,
    // }));

    const updatedFrequencyOptions = (() => {
      if (formData?.HiringType === 6753) {
        return originalFrequencyOptions.filter((option) =>
          [1531, 1530, 1529].includes(option.value)
        );
      } else if (formData?.HiringType === 6754) {
        return originalFrequencyOptions.filter((option) =>
          [1532].includes(option.value)
        );
      } else if (formData?.HiringType === 6835) {
        return originalFrequencyOptions.filter((option) =>
          [1532, 1530, 1529].includes(option.value)
        );
      } else if (formData?.HiringType === 6755) {
        return originalFrequencyOptions.filter((option) =>
          [1531, 1532, 1530, 1529].includes(option.value)
        );
      }
      return originalFrequencyOptions;
    })();

    setFrequencyOption(updatedFrequencyOptions);
  }, [formData?.HiringType]);

  // Original tenure frequency options
  useEffect(() => {
    if (!formData?.CostFrequency) {
      setTenureFrequency([]);
      return;
    }

    // Set options based on CostFrequency value
    const updatedTenureFrequencyOptions = (() => {
      if (formData?.CostFrequency === 1531) {
        return originalTenureFrequency.filter((option) =>
          [1].includes(option.value)
        ); // Show only "Day"
      } else if (formData?.CostFrequency === 1532) {
        return originalTenureFrequency.filter((option) =>
          [1, 2].includes(option.value)
        ); // Show "Day" and "Month"
      } else if (formData?.CostFrequency === 1530) {
        return originalTenureFrequency.filter((option) =>
          [3].includes(option.value)
        ); // Show "Hourly"
      } else if (formData?.CostFrequency === 1529) {
        return originalTenureFrequency.filter((option) =>
          [2].includes(option.value)
        ); // Show "Month"
      }
      return originalTenureFrequency; // Default case (if needed)
    })();

    setTenureFrequency(updatedTenureFrequencyOptions);
  }, [formData?.CostFrequency]);
  // const revenueCalculation = () => {
  //   if (formData.HiringType === 6753) {
  //     // TNM
  //     if (formData.CostFrequency === 1531) {
  //       // Daily
  //       if (formData.TenureFrequency === 1) {
  //         // Day
  //         const revenues =
  //           Number(formData.Tenure) *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Daily Day", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       } else if (formData.TenureFrequency === 2) {
  //         // Monthly
  //         const revenues =
  //           Number(formData.Tenure) *
  //           22 *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Daily Monthly", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       }
  //     } else if (formData.CostFrequency === 1530) {
  //       // Hourly
  //       if (formData.TenureFrequency === 1) {
  //         // Day
  //         const revenues =
  //           Number(formData.Tenure) *
  //           8 *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Hourly Day", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       } else if (formData.TenureFrequency === 2) {
  //         // Monthly
  //         const revenues =
  //           Number(formData.Tenure) *
  //           168 *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Hourly Month", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       }
  //     } else if (formData.CostFrequency === 1529) {
  //       // cost frequency Momthly
  //       if (formData.TenureFrequency === 1) {
  //         // Day
  //         const revenues =
  //           Number(formData.Tenure) *
  //           8 *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Hourly Day", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       } else if (formData.TenureFrequency === 2) {
  //         // Monthly
  //         const revenues =
  //           Number(formData.Tenure) *
  //           168 *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Hourly Month", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       }
  //     } else if (formData.CostFrequency === 1532) {
  //       setFormData({ ...formData, Revenue: formData.Rate });
  //     }
  //   } else if (formData.HiringType === 6754) {
  //     // Fixed Bid
  //     console.log("Check Data for engagement type");
  //     setFormData({ ...formData, Revenue: formData.Rate });
  //   } else if (formData.HiringType === 6823) {
  //     // Adhoc
  //     if (formData.CostFrequency === 1531) {
  //       // Daily
  //       if (formData.TenureFrequency === 1) {
  //         // Day
  //         const revenues =
  //           Number(formData.Tenure) *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Daily Day", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       } else if (formData.TenureFrequency === 2) {
  //         // Monthly
  //         const revenues =
  //           Number(formData.Tenure) *
  //           22 *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Daily Monthly", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       }
  //     } else if (formData.CostFrequency === 1530) {
  //       // Hourly
  //       if (formData.TenureFrequency === 1) {
  //         // Day
  //         const revenues =
  //           Number(formData.Tenure) *
  //           8 *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Hourly Day", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       } else if (formData.TenureFrequency === 2) {
  //         // Monthly
  //         const revenues =
  //           Number(formData.Tenure) *
  //           168 *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Hourly Month", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       }
  //     } else if (formData.CostFrequency === 1532) {
  //       setFormData({ ...formData, Revenue: formData.Rate });
  //     } else if (formData.CostFrequency === 1529) {
  //       if (formData.TenureFrequency === 1) {
  //         // Day
  //         const revenues =
  //           Number(formData.Tenure) *
  //           8 *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Hourly Day", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       } else if (formData.TenureFrequency === 2) {
  //         // Monthly
  //         const revenues =
  //           Number(formData.Tenure) *
  //           168 *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Hourly Month", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       }
  //     }
  //   } else if (formData.HiringType === 6755) {
  //     // POC
  //     if (formData.CostFrequency === 1531) {
  //       // Daily
  //       if (formData.TenureFrequency === 1) {
  //         // Day
  //         const revenues =
  //           Number(formData.Tenure) *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Daily Day", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       } else if (formData.TenureFrequency === 2) {
  //         // Monthly
  //         const revenues =
  //           Number(formData.Tenure) *
  //           22 *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Daily Monthly", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       }
  //     } else if (formData.CostFrequency === 1530) {
  //       // Hourly
  //       if (formData.TenureFrequency === 1) {
  //         // Day
  //         const revenues =
  //           Number(formData.Tenure) *
  //           8 *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Hourly Day", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       } else if (formData.TenureFrequency === 2) {
  //         // Monthly
  //         const revenues =
  //           Number(formData.Tenure) *
  //           168 *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Hourly Month", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       }
  //     } else if (formData.CostFrequency === 1532) {
  //       setFormData({ ...formData, Revenue: formData.Rate });
  //     } else if (formData.CostFrequency === 1529) {
  //       if (formData.TenureFrequency === 1) {
  //         // Day
  //         const revenues =
  //           Number(formData.Tenure) *
  //           8 *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Hourly Day", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       } else if (formData.TenureFrequency === 2) {
  //         // Monthly
  //         const revenues =
  //           Number(formData.Tenure) *
  //           168 *
  //           Number(formData.Rate) *
  //           Number(formData.NumOpenings);
  //         console.log("Hourly Month", revenues);
  //         setFormData({ ...formData, Revenue: revenues });
  //       }
  //     }
  //   }
  // };

  const revenueCalculation = () => {
    if (
      formData.HiringType === 6753 ||
      formData.HiringType === 6755 ||
      formData.HiringType === 6835
    ) {
      // TNM//poc//adhoc
      if (
        (formData.CostFrequency === 1531 && formData.TenureFrequency === 1) ||
        (formData.CostFrequency === 1529 && formData.TenureFrequency === 2) ||
        (formData.CostFrequency === 1530 && formData.TenureFrequency === 3)
      ) {
        const revenues =
          Number(formData.Tenure) *
          Number(formData.Rate) *
          Number(formData.NumOpenings);
        setFormData({ ...formData, Revenue: revenues });
      }
      if (formData.CostFrequency === 1532) {
        // fixed rate

        const revenues = Number(formData.Rate) * Number(formData.NumOpenings);
        setFormData({ ...formData, Revenue: revenues });
      }
    } else if (formData.HiringType === 6754) {
      //fix bid
      if (formData.CostFrequency === 1532) {
        // fixed rate

        const revenues = Number(formData.Rate) * Number(formData.NumOpenings);
        setFormData({ ...formData, Revenue: revenues });
      }
    }
  };

  useEffect(() => {
    revenueCalculation();
  }, [
    formData.TenureFrequency,
    formData.Tenure,
    formData.CostFrequency,
    formData.Currency,
    formData.HiringType,
    formData.Rate,
    formData.NumOpenings,
  ]);
  const internalOption = requirementTypeOptions.find(o => o.code === 'INT');
  const clientReadOnlyFlag = internalOption && (String(formData?.RequirementType) === String(internalOption.value));
  console.log("clientReadOnlyFlag",clientReadOnlyFlag);
  

  if (pageLoading) {
    return (
      <p className="position-absolute top-50 start-50 translate-middle text-center">
        <FaSpinner className="spinner" />
      </p>
    );
  }
  return (
    <>
      <div className="Container">
        <form
          id="formOne"
          className="rounded bg-white mt-2"
          // onSubmit={handleSubmit}
        >
          <div className="mx-2">
            <div className="row row-flex">
              {/* grid one start */}
              <div className="col-md-9 flex-col mt-1">
                <div className="card-body">
                  <div className="row mt-2">
                    <div className="col-sm-2">
                      <label className="form-label">Job Code</label>
                      <input
                        name="JobCode"
                        type="text"
                        readOnly
                        disabled
                        className="form-control"
                        id="JobCode"
                        value={formData.JobCode}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">
                        Date<span className="text-danger ">*</span>
                      </label>
                      <CustomDatePicker
                        handleChange={(e) => handleChange(e)}
                        value={formData.RequirementDate}
                        name="RequirementDate"
                        className={`form-control ${
                          errors?.RequirementDate ? "is-invalid" : ""
                        }`}
                        placeholderText="DD-MMM-YYYY"
                      />
                      <span class="error">{errors?.RequirementDate}</span>
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">
                        Billing Start Date{!clientReadOnlyFlag && <span className="text-danger ">*</span>}
                      </label>
                      <CustomDatePicker
                        handleChange={(e) => handleChange(e)}
                        value={formData.BillingStartDate}
                        name="BillingStartDate"
                        className={`form-control ${
                          errors?.BillingStartDate ? "is-invalid" : ""
                        }`}
                        placeholderText="DD-MMM-YYYY"
                      />
                      <span class="error">{errors?.BillingStartDate}</span>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">Job Title</label>
                      <Select
                        name="PositionName"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        // onChange={(position) =>
                        //   setPositionNameValue(position.value)
                        // }
                        options={jobTitleOption}
                      />
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">Role</label>
                      <span className="text-danger ">*</span>
                      <input
                        type="text"
                        name="Role"
                        className={`form-control ${
                          errors?.Role ? "is-invalid" : ""
                        }`}
                        onChange={handleChange}
                      />
                      <span class="error">{errors?.Role}</span>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-sm-2">
                      <label className="form-label">Job Status</label>
                      <Select
                        name="JobStatus"
                        // onChange={handleSelect}
                        className={` ${errors?.JobStatus ? "is-invalid" : ""}`}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        value={jobStatusOption?.find(
                          (o) => o.value === formData.JobStatus
                        )}
                        options={jobStatusOption}
                      />{" "}
                      <span class="error">{errors?.JobStatus}</span>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Client<span className="text-danger ">*</span>
                      </label>
                      <Select
                        name="ClientID"
                        className={` ${errors?.ClientID ? "is-invalid" : ""}`}
                        onChange={(selectClient, actionMeta) => {
                          handleSelect(selectClient, actionMeta.name);
                        }}
                        options={clientOption}
                        value={clientOption?.find(
                          (o) => o.value === formData.ClientID
                        )}
                      />{" "}
                      <span class="error">{errors?.ClientID}</span>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Requirement Type<span className="text-danger ">*</span>
                      </label>
                      <div className="d-flex align-items-center mt-2" style={{ gap: '15px' }}>
                        {requirementTypeOptions.map((opt) => (
                          <div className="form-check form-check-inline m-0" key={opt.value}>
                            <input
                              className="form-check-input"
                              type="radio"
                              name="RequirementType"
                              id={`reqType_${opt.value}`}
                              value={opt.value}
                              style={{ cursor: "pointer" }}
                              checked={String(formData.RequirementType) === String(opt.value)}
                              onChange={handleChange}
                            />
                            <label className="form-check-label ms-1" htmlFor={`reqType_${opt.value}`} style={{ cursor: "pointer" }}>
                              {opt.label}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">Client POC</label>
                      <input
                        type="text"
                        className="form-control"
                        name="Client_poc"
                        onChange={handleChange}
                        value={formData.Client_poc}
                      />
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">
                        Client Priority<span className="text-danger ">*</span>
                      </label>
                      <Select
                        name="Client_Priority"
                        className={` ${
                          errors?.Client_Priority ? "is-invalid" : ""
                        }`}
                        onChange={(e, action) => handleSelect(e, action.name)}
                        options={clientPriorityOptions}
                        value={clientPriorityOptions?.find(
                          (o) => o.value === formData.Client_Priority
                        )}
                      />{" "}
                      <span class="error">{errors?.Client_Priority}</span>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-sm-3">
                      <label className="form-label">
                        RMG Priority<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="Priority"
                        className={` ${errors?.Priority ? "is-invalid" : ""}`}
                        onChange={(prio, action) =>
                          handleSelect(prio, action.name)
                        }
                        options={priorityOption}
                        value={priorityOption?.find(
                          (o) => o.value === formData.Priority
                        )}
                      />{" "}
                      <span class="error">{errors?.Priority}</span>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Hiring Type<span className="text-danger ">*</span>
                      </label>
                      <Select
                        name="RequirementHiringType"
                        className={` ${
                          errors?.RequirementHiringType ? "is-invalid" : ""
                        }`}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        options={hiringTypeOption}
                      />
                      <span class="error">{errors?.RequirementHiringType}</span>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">Type of Opening</label>
                      <Select
                        name="OpeningType"
                        // onChange={handleSelect}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        options={typeOfOpeningOption}
                      />
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Openings #<span className="text-danger ">*</span>
                      </label>
                      <input
                        type="text"
                        name="NumOpenings"
                        className={`form-control text-end ${
                          errors?.NumOpenings ? "is-invalid" : ""
                        }`}
                        placeholder="No of Opening"
                        onChange={handleChange}
                      />
                      <span class="error">{errors?.NumOpenings}</span>
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-sm-3">
                      <label className="form-label">
                        Total Exp.<span className="text-danger ">*</span>
                      </label>

                      <Select
                        name="MaxExp"
                        className={`form-control-select ${errors?.MaxExp ? "is-invalid" : ""}`}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        options={experienceOptions}
                        value={experienceOptions.find((o) => o.value === formData.MaxExp) || null}
                      />
                      <span class="error">{errors?.MaxExp}</span>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Relevant Exp.<span className="text-danger ">*</span>
                      </label>
                      <Select
                        name="MinExp"
                        className={`form-control-select ${errors?.MinExp ? "is-invalid" : ""}`}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        options={experienceOptions}
                        value={experienceOptions.find((o) => o.value === formData.MinExp) || null}
                      />{" "}
                      <span class="error">{errors?.MinExp}</span>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Engagement Type<span className="text-danger ">*</span>
                      </label>
                      <Select
                        name="HiringType"
                        onChange={(selectedOption, action) => (
                          handleSelect(selectedOption, action.name),
                          setFormData((prevData) => ({
                            ...prevData,
                            TenureFrequency: null,
                            CostFrequency: null,
                            Tenure: null,
                            Rate: null,
                            Currency: null,
                            Revenue: null,
                          }))
                        )}
                        className={` ${errors?.HiringType ? "is-invalid" : ""}`}
                        options={engTypeOption}
                      />{" "}
                      <span class="error">{errors?.HiringType}</span>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">Project Type</label>
                      <Select
                        name="ProjectType"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        value={projectTypeOption?.find(
                          (o) => o.value === formData.ProjectType
                        )}
                        options={projectTypeOption}
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-sm-3">
                      <label className="form-label">Shift Timing</label>
                      <input
                        type="text"
                        className={`form-control`}
                        name="Shift"
                        onChange={handleChange}
                      />
                      {/* <Select name="Shift" onChange={handleSelect}  
                          // options={}
                          />*/}
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">Location Type</label>
                      <Select
                        name="LocationType"
                        className={` ${
                          errors?.LocationType ? "is-invalid" : ""
                        }`}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        options={loctype}
                      />
                      <span class="error">{errors?.LocationType}</span>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Location<span className="text-danger ">*</span>
                      </label>
                      {/* <input
                          type="text"
                          className={`form-control`}
                          name="Location"
                          onChange={handleChange}
                        /> */}
                      <Select
                        menuShouldScrollIntoView={true}
                        isMulti
                        styles={customStyle}
                        name="Location"
                        className={`basic-multi-select ${
                          errors?.Location ? "is-invalid" : ""
                        }`}
                        classNamePrefix="select"
                        onChange={(e) => handleMultiSelect(e, "Location")}
                        options={[
                          ...locationOption,
                        ]}
                      />{" "}
                      <span class="error">{errors?.Location}</span>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Skills<span className="text-danger ">*</span>
                      </label>
                      <Select
                        menuShouldScrollIntoView={true}
                        isMulti
                        styles={customStyle}
                        name="skill"
                        className={`basic-multi-select ${
                          errors?.skill ? "is-invalid" : ""
                        }`}
                        classNamePrefix="select"
                        // onChange={handleSkillChange}
                        onChange={(e) => {
                          handleSkillChange(e); // Call the skill change handler
                          handleMultiSelect(e, "skill"); // Call the multi-select handler
                        }}
                        options={skillSetOptions}
                      />
                      <span class="error">{errors?.skill}</span>
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-sm-3">
                      <label className="form-label">RMG POC</label>
                      <Select
                        name="RomID"
                        onChange={(selected, action) =>
                          handleSelect(selected, action.name)
                        }
                        options={clientSelectRomPoc}
                        // value={clientSelectRomPocvalue}
                        value={clientSelectRomPoc.find(
                          (o) => o.value === formData.RomID
                        )}
                      />
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">A/C Manager</label>
                      <Select
                        name="AccountManager"
                        // onChange={(selected) =>
                        //   setClientSelectAccountManagervalue(selected)
                        // }

                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        options={clientSelectAccountManager}
                        // value={clientSelectAccountManagervalue}
                        value={clientSelectAccountManager.find(
                          (o) => o.value === formData.AccountManager
                        )}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Client Partner</label>
                      <input
                        type="text"
                        className="form-control"
                        disabled
                        value={clientPartnerValue}
                        readOnly
                      />
                      {/* <span class="error">{errors?.ClientID}</span> */}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Delivery Partner</label>
                      <input
                        type="text"
                        className="form-control"
                        disabled
                        value={deliveryPartnerValue}
                        readOnly
                      />
                      {/* <Select name="Shift" onChange={handleSelect}  
                          // options={}
                          />*/}
                    </div>
                    {/* <div className="col-sm-3">
                      <label className="form-label">Project Type</label>
                      <Select
                        name="ProjectType"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        value={projectTypeOption?.find(o => o.value === formData.ProjectType)}
                        options={projectTypeOption}
                      />
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Location<span className="text-danger ">*</span>
                      </label>
                      <Select
                        menuShouldScrollIntoView={true}
                        isMulti
                        styles={customStyle}
                        name="Location"
                        className={`basic-multi-select ${errors?.Location ? "is-invalid" : ""
                          }`}
                        classNamePrefix="select"
                        onChange={(e) => handleMultiSelect(e, "Location")}
                        options={locationOption}
                      />{" "}
                      <span class="error">{errors?.Location}</span>
                    </div> */}
                  </div>
                    <div className="row mt-4">
                      <div className="col-sm-3">
                          <label className="form-label">
                            Currency
                            {/* Only show the red asterisk if the field is NOT read-only */}
                            {!clientReadOnlyFlag && <span className="text-danger">*</span>}
                          </label>
                          
                          <Select
                            name="Currency"
                            /* FIX 1: Custom dropdowns use 'isDisabled', NOT 'readOnly' */
                            isDisabled={clientReadOnlyFlag}
                            
                            /* FIX 2: Prevent the selection change if the flag is true */
                            onChange={(selectedOption, action) => {
                              if (!clientReadOnlyFlag) {
                                handleSelect(selectedOption, action.name);
                              }
                            }}
                            value={
                              currecyOption?.find(
                                (o) => o.value === formData?.Currency
                              ) || null
                            }
                            
                            /* FIX 3: Style the container with Bootstrap's 'pe-none' to prevent clicks when locked */
                            className={`${clientReadOnlyFlag ? "pe-none" : ""} ${
                              errors?.Currency ? "is-invalid" : ""
                            }`}
                            options={currecyOption}
                          />{" "}
                          
                          {/* Only show validation errors if the field is not locked */}
                          {!clientReadOnlyFlag && <span className="error">{errors?.Currency}</span>}
                        </div>
                      <div className="col-sm-3">
                          <label className="form-label">
                            Cost Frequency
                            {/* Only show the red asterisk if the field is NOT locked */}
                            {!clientReadOnlyFlag && <span className="text-danger">*</span>}
                          </label>
                          
                          <Select
                            name="CostFrequency"
                            /* FIX 1: Use isDisabled instead of readOnly for custom dropdowns */
                            isDisabled={clientReadOnlyFlag}
                            
                            /* FIX 2: Guard the change handler so state can't be modified when locked */
                            onChange={(selectedOption, action) => {
                              if (!clientReadOnlyFlag) {
                                handleSelect(selectedOption, action.name);
                              }
                            }}
                            value={
                              frequencyOption?.find(
                                (o) => o.value === formData?.CostFrequency
                              ) || null
                            }
                            
                            /* FIX 3: Add 'pe-none' when locked to completely freeze user mouse interactions */
                            className={`${clientReadOnlyFlag ? "pe-none" : ""} ${
                              errors?.CostFrequency ? "is-invalid" : ""
                            }`}
                            options={frequencyOption}
                          />{" "}
                          
                          {/* Hide the error message text if the client field is locked */}
                          {!clientReadOnlyFlag && <span className="error">{errors?.CostFrequency}</span>}
                        </div>
                      <div className="col-sm-3">
                        <label className="form-label">
                          Rate
                          {/* Only show the red asterisk if the field is NOT locked */}
                          {!clientReadOnlyFlag && <span className="text-danger">*</span>}
                        </label>
                        <input
                          type="number"
                          name="Rate"
                          readOnly={clientReadOnlyFlag}
                          
                          /* FIX 1: Turn off the change handler completely when the client is locked */
                          onChange={clientReadOnlyFlag ? undefined : handleChange}
                          value={formData?.Rate || ""}
                          
                          /* FIX 2: Dynamic classes. 'bg-light' greys out the background, 'pe-none' stops mouse clicks */
                          className={`form-control ${clientReadOnlyFlag ? "bg-light pe-none" : ""} ${
                            (!clientReadOnlyFlag && errors?.Rate) ? "is-invalid" : ""
                          }`}
                          
                          /* FIX 3: Prevents keyboard users from tabbing into the field when locked */
                          tabIndex={clientReadOnlyFlag ? -1 : 0}
                        />{" "}
                        
                        {/* Hide the validation error message text if the field is locked */}
                        {!clientReadOnlyFlag && <span className="error">{errors?.Rate}</span>}
                      </div>
                      <div className="col-sm-3">
                        <label className="form-label">
                          Tenure
                          {/* Only show the red asterisk if the client is NOT 354 */}
                          {!clientReadOnlyFlag && <span className="text-danger">*</span>}
                        </label>
                        <input
                          type="number"
                          name="Tenure"
                          readOnly={clientReadOnlyFlag}
                          /* FIX 1: If client is locked, block the change handler entirely */
                          onChange={clientReadOnlyFlag ? undefined : handleChange}
                          value={formData?.Tenure || ""}
                          /* FIX 2: Dynamic classes. 'bg-light' greys it out, 'pe-none' stops mouse clicks */
                         className={`form-control ${clientReadOnlyFlag ? "bg-light pe-none" : ""} ${
                            (!clientReadOnlyFlag && errors?.Tenure) ? "is-invalid" : ""
                          }`}
                          /* FIX 3: Prevents users from focusing it using the 'Tab' key */
                          tabIndex={clientReadOnlyFlag ? -1 : 0}
                        />{" "}
                        {/* Only show the error span if it's not locked */}
                        {!clientReadOnlyFlag && <span className="error">{errors?.Tenure || ""}</span>}
                      </div>
                    </div>
                  <div className="row mt-2">
                      <div className="col-sm-3">
                        <label className="form-label">Revenue</label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="revenue"
                            name="Revenue"
                            readOnly={clientReadOnlyFlag}
                            value={`${formData.Revenue || ""} ${
                              currecyOption?.find(
                                (o) => o?.value === formData?.Currency
                              )?.symbol || ""
                            }`}
                            
                            /* FIX 1: Safely handle or block onChange depending on the flag */
                            onChange={clientReadOnlyFlag ? undefined : handleChange} 
                            
                            /* FIX 2: Dynamic Bootstrap classes. 'bg-light' greys it out, 'pe-none' blocks mouse interaction */
                            className={`form-control me-2 ${clientReadOnlyFlag ? "bg-light pe-none" : ""}`}
                            
                            /* FIX 3: Prevents users from tabbing into the field when it's locked */
                            tabIndex={clientReadOnlyFlag ? -1 : 0}
                            style={{ textAlign: "left" }}
                          />
                        </div>
                      </div>
                    <div className="col-md-3">
                      <label class="form-label">
                        Region
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <Select
                        name="RegionID"
                        // onChange={handleCountry}
                        // className={` ${errors.CountryID ? "is-invalid" : ""}`}
                        onChange={(e, action) => handleSelect(e, action.name)}
                        value={regionoption.find(
                          (o) => o.value == formData.RegionID
                        )}
                        class="form-control"
                        options={regionoption}
                      />
                      {/* <span class="error">{errors?.CountryID}</span> */}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Track{formData.RequirementHiringType === "1" && <span className="text-danger">*</span>}</label>
                      <Select
                        name="TrackerID"
                        onChange={(e, action) => handleSelect(e, action.name)}
                        value={trackOption.find((o) => o.value == formData.TrackerID)}
                        className={`form-control-select ${errors?.TrackerID ? "is-invalid" : ""}`}
                        isDisabled={formData.RequirementHiringType !== "1"}
                        options={trackOption}
                      />
                      <span className="error">{errors?.TrackerID}</span>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Job Family{formData.RequirementHiringType === "1" && <span className="text-danger">*</span>}</label>
                      <Select
                        name="JobFamilyID"
                        onChange={(e, action) => handleSelect(e, action.name)}
                        value={jobFamilyOption.find((o) => o.value == formData.JobFamilyID)}
                        className={`form-control-select ${errors?.JobFamilyID ? "is-invalid" : ""}`}
                        isDisabled={formData.RequirementHiringType !== "1"}
                        options={jobFamilyOption}
                      />
                      <span className="error">{errors?.JobFamilyID}</span>
                    </div>
                  </div>
                  <div className="row mt-2">
                      <div className="col-md-2">
                        <label className="form-label">Personal Sub Area{formData.RequirementHiringType === "1" && <span className="text-danger">*</span>}</label>
                        <Select
                          name="PersonalSubAreaID"
                          onChange={(e, action) => handleSelect(e, action.name)}
                          value={personalSubAreaOption.find((o) => o.value == formData.PersonalSubAreaID)}
                          className={`form-control-select ${errors?.PersonalSubAreaID ? "is-invalid" : ""}`}
                          isDisabled={formData.RequirementHiringType !== "1"}
                          options={personalSubAreaOption}
                        />
                        <span className="error">{errors?.PersonalSubAreaID}</span>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Requisition Source{formData.RequirementHiringType === "1" && <span className="text-danger">*</span>}</label>
                        <Select
                          name="RequisitionSourceID"
                          onChange={(e, action) => handleSelect(e, action.name)}
                          value={requisitionSourceOption.find((o) => o.value == formData.RequisitionSourceID)}
                          className={`form-control-select ${errors?.RequisitionSourceID ? "is-invalid" : ""}`}
                          isDisabled={formData.RequirementHiringType !== "1"}
                          options={requisitionSourceOption}
                        />
                        <span className="error">{errors?.RequisitionSourceID}</span>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Employee Group{formData.RequirementHiringType === "1" && <span className="text-danger">*</span>}</label>
                        <Select
                          name="EmployeeGroup_ID"
                          onChange={(e, action) => handleSelect(e, action.name)}
                          value={employeeGroupOption.find((o) => o.value == formData.EmployeeGroup_ID)}
                          className={`form-control-select ${errors?.EmployeeGroup_ID ? "is-invalid" : ""}`}
                          isDisabled={formData.RequirementHiringType !== "1"}
                          options={employeeGroupOption}
                        />
                        <span className="error">{errors?.EmployeeGroup_ID}</span>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Billing Type{formData.RequirementHiringType !== "4" && <span className="text-danger">*</span>}</label>
                        <Select
                          name="BillingTypeID"
                          onChange={(e, action) => handleSelect(e, action.name)}
                          value={billingTypeOption.find((o) => o.value == formData.BillingTypeID) || null}
                          className={`form-control-select ${errors?.BillingTypeID ? "is-invalid" : ""}`}
                          isDisabled={formData.RequirementHiringType === "4"}
                          options={billingTypeOption}
                        />
                        <span className="error">{errors?.BillingTypeID}</span>
                      </div>
                      <div className="col-md-3">
                          <label className="form-label">RMG Status{formData.RequirementHiringType === "1" && <span className="text-danger">*</span>}</label>
                          <Select
                            name="RMGStatusID"
                            className={`form-control-select ${errors?.RMGStatusID ? "is-invalid" : ""}`}
                            onChange={(selectedOption, action) =>
                              handleSelect(selectedOption, action.name)
                            }
                            value={rmgStatusOption?.find(
                              (o) => String(o.value) === String(formData.RMGStatusID)
                            )}
                            options={rmgStatusOption}
                          />
                          <span className="error">{errors?.RMGStatusID}</span>
                      </div>
                  </div>
                  </div>
                </div>
              <div className="col-md-3">
                  <div className="row mt-2">
                    <div className="col-sm-12">
                      <label className="form-label">Remark Reg. Job Status</label>
                      <div className="d-flex align-items-center">
                        <textarea
                          id="Reason"
                          name="Reason"
                          className="form-control me-2"
                          style={{ textAlign: "left", resize: "none" }}
                          rows={5}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    </div>
                    <div className="row mt-3">
                    <div className="col-sm-12">
                      <label className="form-label">Description</label>
                      <span className="text-danger">*</span>
                      <EditorComponent
                        value={formData.Description || ""}
                        className={` ${
                          errors?.Description ? "is-invalid" : ""
                        }`}
                        onEditorChange={(content) => {
                          setFormData({ ...formData, Description: content }); // Update formData with new Description
                          validateField("Description", content); // Validate the Description field with the new content
                        }}
                      />
                      <span class="error">{errors?.Description}</span>
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-sm-12">
                      <label className="form-label">
                        SubSkills<span className="text-danger ">*</span>
                      </label>
                      <Select
                        isMulti
                        styles={customStyle}
                        name="Technology"
                        className={`basic-multi-select ${
                          errors?.Technology ? "is-invalid" : ""
                        }`}
                        value={formData.Technology || null}
                        classNamePrefix="select"
                        // onChange={handleSubSkillChange}
                        onChange={(e) => {
                          handleSubSkillChange(e);
                          handleMultiSelect(e, "Technology");
                        }}
                        options={subSkillOption1}
                      />
                      <span class="error">{errors?.Technology}</span>
                    </div>
                    </div>
                    <div className="row mt-2">
                    <div className="col-sm-12">
                      <label className="form-label">Project Manager</label>
                      <input
                        type="text"
                        className="form-control"
                        disabled
                        value={projectManagerValue}
                        readOnly
                      />
                      {/* <span class="error">{errors?.ClientID}</span> */}
                    </div>
                    </div>
                      <div className="row mt-4"> 
                        <div className="col-sm-12">
                        <label className="form-label">
                          Tenure Frequency
                          {/* Only show the red asterisk if the field is NOT locked */}
                          {!clientReadOnlyFlag && <span className="text-danger">*</span>}
                        </label>
                        
                        <Select
                          name="TenureFrequency"
                          /* FIX 1: Custom dropdown components require isDisabled */
                          isDisabled={clientReadOnlyFlag}
                          
                          /* FIX 2: Safeguard the selection change so state doesn't update when locked */
                          onChange={(selectedOption, action) => {
                            if (!clientReadOnlyFlag) {
                              handleSelect(selectedOption, action.name);
                            }
                          }}
                          value={
                            tenureFrequency?.find(
                              (o) => o.value === formData?.TenureFrequency
                            ) || null
                          }
                          
                          /* FIX 3: Add 'pe-none' when locked to freeze all user mouse interactions */
                          className={`${clientReadOnlyFlag ? "pe-none" : ""} ${
                            errors?.TenureFrequency ? "is-invalid" : ""
                          }`}
                          options={tenureFrequency}
                        />{" "}
                        
                        {/* Hide the validation error text if the field is locked */}
                        {!clientReadOnlyFlag && <span className="error">{errors?.TenureFrequency}</span>}
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-sm-12">
                        <label className="form-label">Personal Area{formData.RequirementHiringType === "1" && <span className="text-danger">*</span>}</label>
                        <Select
                          name="PersonalAreaID"
                          onChange={(e, action) => handleSelect(e, action.name)}
                          value={personalAreaOption.find((o) => o.value == formData.PersonalAreaID)}
                          className={`form-control-select ${errors?.PersonalAreaID ? "is-invalid" : ""}`}
                          isDisabled={formData.RequirementHiringType !== "1"}
                          options={personalAreaOption}
                        />
                        <span className="error">{errors?.PersonalAreaID}</span>
                      </div>
                    </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 pb-2">
            <div className="d-flex justify-content-end align-items-end m-2  text-right me-2">
              <button
                type="button"
                className="cancel-btn me-2"
                onClick={() => navigate("/customer-requirement")}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSubmit}
                className="custom-btn "
                disabled={loading ? true : false}
              >
                {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddCustomerRequirement;
